/* Main Project — Lazy autoplay videos.
   Videos ship with data-lazy-src + preload="none" (no src, no autoplay):
   zero video bytes on page load. When a video scrolls near the viewport its
   src is attached and it plays; off-screen videos pause. Hidden elements
   (e.g. inactive PDP color variants, display:none) never intersect, so they
   never download — they load on first reveal instead. */
(function () {
  function activate(v) {
    if (!v.src && v.dataset.lazySrc) v.src = v.dataset.lazySrc;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-lazy-src]'));
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(activate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) activate(e.target);
        else if (e.target.src) e.target.pause();
      });
    }, { rootMargin: '120px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
